<!--
 * @Name: menuDisabled
 * @Description: 菜单禁用
 * @Author: xiadongxue
 * @Date: 2022-01-25 15:32:18
 * @Editors: xiadongxue
-->
<template>
<div
    class="menu-wrap"
    v-loading="loading">
    <div class="header-icon">
        <div
            class="click-icon add_icon"
            :class="{'not-icon':!toShow}"
            @click="toEditMenu(false)"></div>
        <div
            :class="{'not-icon':!toShow}"
            class="click-icon refresh_icon"
            @click="refresh"></div>
        <search
            :data="{
                projectList: projectList,
                roleList: roleList
            }"
            :isRole="true"
            :searchForm="searchForm"
            :searchData="filter"
            @update="selectRole"
            @submit="toSearch" />
    </div>
    <el-table
        :data="list"
        style="width: 100%"
        stripe
        border>
        <el-table-column
            v-for="item in tableColumn"
            :key="item.prop"
            align="center"
            :prop="item.prop"
            :label="item.label" />
        <el-table-column
            label="操作"
            align="center"
            width="150">
            <template v-slot="{row}">
                <el-button
                    type="text"
                    @click="toEditMenu(row)">编辑</el-button>
                <el-button
                    type="text"
                    @click="toCopyMenu(row)">复制</el-button>
                <el-button
                    type="text"
                    @click="deleteMenu(row.id)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog
        v-loading="loading"
        :title="`菜单信息${copy ? '——复制到大区' : ''}`"
        :visible.sync="visible"
        :modal-append-to-body="false"
        @close="close"
        width="700px">
        <el-form
            label-width="170px"
            ref="form"
            :model="menuData"
            :rules="menuRules">
            <div>
                <el-form-item
                    prop="projectId"
                    label="子系统">
                    <el-select
                        disabled
                        size="small"
                        v-model="filter.projectId">
                        <el-option
                            v-for="item in projectList"
                            :key="item.projectId"
                            :value="item.projectId"
                            :label="item.projectName" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    prop="roleId"
                    label="角色">
                    <el-select
                        disabled
                        size="small"
                        v-model="filter.roleId">
                        <el-option
                            v-for="item in roleList"
                            :key="item.roleId"
                            :value="item.roleId"
                            :label="item.roleName" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    prop="ssoAppId"
                    label="应用名称">
                    <el-select
                        :disabled="!add"
                        size="small"
                        @change="ssoAppIdChange"
                        v-model="menuData.ssoAppId">
                        <el-option
                            v-for="item in userAppList"
                            :key="item.ssoAppId"
                            :value="item.ssoAppId"
                            :label="item.appName" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    label="源大区"
                    v-show="copy">
                    <el-select
                        disabled
                        size="small"
                        v-model="menuData.sourceAreaId">
                        <el-option
                            v-for="item in userAreaList"
                            :key="item.areaId"
                            :value="item.areaId"
                            :label="item.areaName" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    prop="areaId"
                    :label="copy ? '目标大区' : '大区名称'">
                    <el-select
                        :disabled="!add && !copy"
                        size="small"
                        v-model="menuData.areaId">
                        <el-option
                            v-for="item in userAreaList"
                            :key="item.areaId"
                            :value="item.areaId"
                            :label="item.areaName" />
                    </el-select>
                </el-form-item>
                <el-form-item
                    v-show="!copy"
                    prop="menuIdsExcluded"
                    label="菜单禁用">
                    <select-menu
                        :menuList="menuList"
                        :userDisabled="true"
                        :value.sync="menuData.menuIdsExcluded" />
                </el-form-item>
            </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button
                @click="close"
                size="small">取消</el-button>
            <el-button
                @click="toSubmit"
                size="small"
                type="danger">确定</el-button>
        </span>
    </el-dialog>
</div>
</template>

<script>
import Search from '@/components/Search.vue';
import SelectMenu from './components/SelectMenu.vue';
import {
    menuGet,
    userApp,
    userArea,
    menuInsert,
    menuCopy,
    menuUpdate,
    menuDelete,
    getMenuByProject
} from './api';
import {
    simpleFindRoles
} from '@/api'
import {
    mapGetters
} from 'vuex';
export default {
    name: 'menuDisabled',
    components: {
        Search,
        SelectMenu,
    },
    computed: {
        ...mapGetters(['projectList', 'projectId']),
        toShow() {
            return this.filter.roleId && (this.filter.projectId || this.filter.projectId === 0)
        }
    },
    data() {
        return {
            loading: false,
            //添加&修改弹窗显示
            visible: false,
            //是否为添加菜单
            add: false,
            //是否为复制
            copy: false,
            //添加&修改表单项
            defaultMenuData: {
                ssoAppId: '',
                areaId: '',
                menuIdsExcluded: []
            },
            menuData: {},
            //筛选配置项
            searchForm: [{
                    type: 'select',
                    key: 'projectId',
                    label: '子系统',
                    data: 'projectList',
                    value: 'projectId',
                    name: 'projectName',
                    required: true,
                    relate: true,
                    relateKey: 'roleId',
                    relateUpdate: 'update'
                },
                {
                    type: 'select',
                    key: 'roleId',
                    label: '角色',
                    data: 'roleList',
                    value: 'roleId',
                    name: 'roleName',
                    required: true,
                },
            ],
            //筛选默认项
            filter: {
                projectId: '',
                roleId: '',
            },
            //表格数据
            list: [],
            tableColumn: [{
                    prop: 'projectName',
                    label: '所属项目',
                }, {
                    prop: 'bizAppId',
                    label: '应用ID',
                },
                {
                    prop: 'appName',
                    label: '应用名称',
                },
                {
                    prop: 'bizAreaId',
                    label: '大区ID',
                },
                {
                    prop: 'areaName',
                    label: '大区名称',
                },
                {
                    prop: 'menuExcludedListName',
                    label: '禁用菜单'
                }
            ],
            menuRules: {
                ssoAppId: [{
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                }, ],
                areaId: [{
                    required: true,
                    message: '请选择',
                    trigger: 'change',
                }, ],
                menuIdsExcluded: [{
                    required: true,
                    trigger: 'change',
                    validator: (rule, value, callback) => {
                        if (this.copy) {
                            callback()
                        } else {
                            if (value && value.length) {
                                callback()
                            } else {
                                callback(new Error('请选择'))
                            }
                        }
                    }
                }],
            },
            //应用列表
            userAppList: [],
            //大区列表
            userAreaList: [],
            //角色列表
            roleList: [],
            //菜单项
            menuList: []
        };
    },
    created() {
        this.$watch('projectList', val => {
            if (val.length && !this.$route.query.projectId) {
                this.filter.projectId = this.projectId
                //获取角色列表
                this.selectRole(this.projectId);
            }
        })

        let roleId = Number(this.$route.query.roleId);
        let projectId = Number(this.$route.query.projectId);
        //菜单禁用跳转
        if (roleId && (projectId || projectId === 0)) {
            this.filter = {
                roleId,
                projectId,
            };
            //获取角色列表
            this.selectRole(projectId);
            //查询
            this.toSearch(this.filter);
            this.$store.dispatch('changeProjectId', this.filter.projectId);
        } else if (this.projectList.length) {
            this.filter.projectId = this.projectId
            //获取角色列表
            this.selectRole(this.projectId);
        }
    },
    methods: {
        //点击查询
        async toSearch(filter) {
            try {
                this.loading = true;
                this.filter = JSON.parse(JSON.stringify(filter));
                let {
                    code,
                    result
                } = await menuGet(filter);
                if (code === 0) {
                    //获取应用
                    this.toGetApp()
                    let project = this.projectList.find(i => i.projectId === this.filter.projectId)
                    this.list = result.map(item => {
                        item.projectName = project.projectName
                        item.menuExcludedListName = item.menuExcludedList.map(menu => menu.menuName).join('、')
                        return item
                    });
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
        //获取应用
        async toGetApp() {
            try {
                let {
                    result,
                    code
                } = await userApp({
                    roleId: this.filter.roleId,
                });
                if (code === 0) {
                    this.userAppList = result;
                }
            } catch (error) {
                console.log(error);
            }
        },
        //获取大区
        async toGetArea() {
            try {
                let {
                    result,
                    code
                } = await userArea({
                    roleId: this.filter.roleId,
                    ssoAppId: this.menuData.ssoAppId,
                });
                if (code === 0) {
                    this.userAreaList = result;
                }
            } catch (error) {
                console.log(error);
            }
        },
        //角色列表
        async selectRole(value) {
            try {
                if (!value && value !== 0) {
                    this.roleList = []
                    return
                }
                let {
                    code,
                    result
                } = await simpleFindRoles({
                    projectId: value
                })
                if (code === 0) {
                    this.roleList = result
                }
            } catch (error) {
                console.log(error)
            }
        },
        //应用切换
        ssoAppIdChange() {
            this.menuData.areaId = ''
            this.menuData.menuIdsExcluded = []
            this.toGetArea()
            this.toGetMenuList()
        },
        //获取菜单
        async toGetMenuList() {
            try {
                let {
                    result,
                    code
                } = await getMenuByProject({
                    projectId: this.filter.projectId,
                    ssoAppId: this.menuData.ssoAppId,
                });
                if (code === 0) {
                    this.menuList = result;
                }
            } catch (error) {
                console.log(error);
            }
        },
        //重置
        refresh() {
            if (!this.toShow) {
                return
            }
            if (this.filter.roleId) {
                this.toSearch(this.filter)
            } else {
                this.list = []
            }
        },
        //删除
        async deleteMenu(id) {
            try {
                let res = await this.$confirm('确定删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                });
                if (res) {
                    let {
                        code
                    } = await menuDelete({
                        id
                    });
                    if (code === 0) {
                        this.$message.success('删除成功');
                        this.toSearch(this.filter);
                    }
                }
            } catch (error) {
                console.log(error);
            }
        },
        //弹窗关闭
        close() {
            this.visible = false;
            this.add = false;
            this.copy = false;
            this.menuData = JSON.parse(JSON.stringify(this.defaultMenuData));
            this.$nextTick(this.$refs['form'].clearValidate);
        },
        //点击确定
        toSubmit() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    //通过校验
                    if (this.copy) {
                        this.copySave();
                    } else {
                        this.toSave();
                    }
                } else {
                    return false;
                }
            });
        },
        //保存
        async toSave() {
            try {
                this.loading = true;
                let Fn = menuInsert;

                let data = {
                    ssoAppId: this.menuData.ssoAppId,
                    areaId: this.menuData.areaId,
                    projectId: this.filter.projectId,
                    menuIdsExcluded: this.menuData.menuIdsExcluded
                }
                if (this.add) {
                    data.roleId = this.filter.roleId
                    data.areaName = this.userAreaList.find(item => item.areaId === this.menuData.areaId).areaName
                } else {
                    Fn = menuUpdate
                    data.id = this.menuData.id
                    data.userId = this.menuData.userId
                    data.areaName = this.menuData.areaName
                }

                let {
                    code
                } = await Fn(data);
                if (code === 0) {
                    this.$message.success(`${this.add ? '添加' : '修改'}成功`);
                    this.toSearch(this.filter);
                    this.close();
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        },
        //编辑菜单
        toEditMenu(row) {
            if (!this.toShow) {
                return
            }
            this.menuData = !row ? JSON.parse(JSON.stringify(this.defaultMenuData)) : JSON.parse(JSON.stringify(row));
            if (row) {
                this.toGetArea()
                this.toGetMenuList()
            }
            this.visible = true;
            this.add = !row;
        },
        //复制菜单禁用
        toCopyMenu(row) {
            this.copy = true
            this.visible = true
            this.menuData = {
                ssoAppId: row.ssoAppId,
                sourceAreaId: row.areaId
            }
            this.toGetArea()
        },
        async copySave() {
            try {
                this.loading = true;

                let data = {
                    ssoAppId: this.menuData.ssoAppId,
                    targetAreaId: this.menuData.areaId,
                    projectId: this.filter.projectId,
                    sourceAreaId: this.menuData.sourceAreaId,
                    roleId: this.filter.roleId,
                    targetAreaName: this.userAreaList.find(item => item.areaId === this.menuData.areaId).areaName
                }

                let {
                    code
                } = await menuCopy(data);
                if (code === 0) {
                    this.$message.success('复制成功');
                    this.toSearch(this.filter);
                    this.close();
                }
                this.loading = false;
            } catch (error) {
                this.loading = false;
                console.log(error);
            }
        }
    },
};
</script>

<style lang="scss">
.el-select,
.el-input,
.el-textarea,
.el-cascader {
    width: 300px;
}
</style>
